import { render, staticRenderFns } from "./TiWenChart.vue?vue&type=template&id=45bdc4d2&scoped=true&"
import script from "./TiWenChart.vue?vue&type=script&lang=js&"
export * from "./TiWenChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bdc4d2",
  null
  
)

export default component.exports